(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('PatchReportSearch', PatchReportSearch);

    PatchReportSearch.$inject = ['$resource'];

    function PatchReportSearch($resource) {
        var resourceUrl =  'api/_search/patch-reports/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
